// @ts-nocheck 02aa4b3f
import { array } from '#packages/util';
import wixFormsConstants from '../../contact/wixForms/constants';
import * as wixFormsUtils from '../../contact/wixForms/utils';

const addForm = (structure) => {
  const form = wixFormsUtils.getFormWidget({
    layout: {
      width: 310,
      height: 331,
      x: 58,
      y: 208,
      scale: 1,
      rotationInDegrees: 0,
      anchors: [
        {
          distance: 56,
          originalValue: 540,
          type: 'BOTTOM_PARENT',
          locked: true,
          targetComponent: 'comp-im2561qg',
        },
      ],
      fixedPosition: false,
    },
    id: 'comp-im2561q5',
    mobileLayout: {
      width: 290,
      height: 319,
      x: 16,
      y: 149,
      scale: 1,
      rotationInDegrees: 0,
      anchors: [
        {
          distance: 57,
          topToTop: 165,
          originalValue: 595,
          type: 'BOTTOM_PARENT',
          locked: true,
          targetComponent: 'comp-im2561qg',
        },
      ],
      fixedPosition: false,
    },
  });

  // add form to
  // components: [
  //     component_0: {
  //         components: [
  //             form,
  //             ...
  //         ]
  //     },
  // ]
  return {
    ...structure,
    components: array.immutableSplice(structure.components, 0, 1, {
      ...structure.components[0],
      components: array.immutableSplice(
        structure.components[0].components,
        0,
        0,
        form,
      ),
    }),
  };
};

export default (onDrop, onClick) => (item) => {
  onDrop = onDrop(wixFormsConstants.FormPreset.LIGHTBOX_CONTACT05);
  onClick = onClick(wixFormsConstants.FormPreset.LIGHTBOX_CONTACT05);

  return {
    ...item,
    onDrop,
    onClick,
    structure: addForm(item.structure),
  };
};
